import { Theme, Tooltip } from '@material-ui/core'
import { withStyles, WithStyles, CSSProperties } from '@material-ui/styles'
import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

const styles = (theme: Theme) => ({
    subTitle: {
        display: 'flex',
        flexDirection: 'row',
        fontStyle: 'normal',
        fontWeight: 400,
        width: '100%',
        fontSize: 12,
        whiteSpace: 'pre',
        lineHeight: '16px',
        letterSpacing: 0.4,
        color: '#fff',
    } as CSSProperties,
    tooltip: {
        display: 'flex',
        alignItems: 'center',
        paddingRight: '8px!important',
        paddingLeft: '8px!important',
        height: 24,
        top: -45,
        position: 'absolute',
        background: '#4A4A4F',
        boxSizing: 'border-box',
        border: '1px solid #D7D7DB',
        borderRadius: 4,
    } as CSSProperties,
    popper: {
        padding: '0px!important',
        opacity: 1,
    } as CSSProperties,
    content: {
        position: 'relative',
        background: '#4A4A4F',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: 'fit-content'
    } as CSSProperties,
    triangle: {
        position: 'absolute',
        bottom: -8,
        left: 0,
        background: '#4A4A4F',
        transform: 'rotate(45deg)',
        border: `solid 1px #D7D7DB`,
        width: 6,
        height: 6,
        borderLeft: `1px solid transparent`,
        borderTop: `1px solid transparent`,
        zIndex: 3
    } as CSSProperties,
})

interface Props extends WithStyles<typeof styles> {
    component: ReactNode
}
interface PropsInner extends WithStyles<typeof styles> {
}

const CalculatedFieldTooltipInner = (props: PropsInner) => {
    const {classes} = props
    const [t] = useTranslation("i18_item")
    const Info = <div className={classes.subTitle}>{t("Read-only calculated field")}</div>

    return <div className={classes.content}>
        {Info}
        <div className={classes.triangle} />
    </div>
}

const CalculatedFieldTooltip = (props: Props) => {
    const {classes, component} = props

    return <div style={{position: 'relative'}}><Tooltip interactive classes={{tooltip: classes.tooltip, popper: classes.popper}} title={<CalculatedFieldTooltipInner classes={classes} />} placement="top-start">
        <div>{component}</div>
    </Tooltip></div>
}

export default withStyles(styles)(CalculatedFieldTooltip)